

// CreateCardIndividualOrTeamMemberModal.jsx
import React from 'react';
import { Box, Typography } from '@mui/material';
import { PersonOutlineOutlinedIcon, GroupsOutlinedIcon } from 'icons/materialIcons';

const CreateCardIndividualOrTeamMemberModal = ({
  isOpen,
  onClose,
  onSelect,
  anchorEl,
  offset = 70,
  horizontalOffset = 0
}) => {
  if (!isOpen) return null;

  const getModalPosition = () => {
    if (!anchorEl) return {};

    const anchorRect = anchorEl.getBoundingClientRect();
    const modalTop = anchorRect.bottom + offset;
    const modalLeft = anchorRect.left + (anchorRect.width / 2) + horizontalOffset;

    return {
      top: modalTop,
      left: modalLeft,
    };
  };

  const { top, left } = getModalPosition();

  const handleOverlayClick = (e) => {
    e.stopPropagation();
    onClose();
  };

  const boxStyles = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #e0e0e0',
    borderRadius: '0.5rem',
    padding: '1rem',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    width: '8rem',
    height: '7rem',
    boxSizing: 'border-box',
    '&:hover': {
      backgroundColor: '#f5f5f5',
      borderColor: '#828282',
    },
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1100,
        backgroundColor: 'transparent',
      }}
      onClick={handleOverlayClick}
    >
      <Box
        sx={{
          position: 'absolute',
          top: `${top}px`,
          left: `${left}px`,
          transform: 'translateX(-50%)',
          backgroundColor: '#fff',
          borderRadius: '0.5rem',
          padding: '1.25rem',
          width: '90%',
          maxWidth: '20rem',
          textAlign: 'center',
          boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.08), 0px 2px 8px rgba(0, 0, 0, 0.04)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <Typography
          variant="h6"
          sx={{
            textAlign: 'center',
            marginBottom: '1rem',
            fontWeight: 600,
            fontSize: '1rem'
          }}
        >
          Who is this card for?
        </Typography>

        <Box
          sx={{
            display: 'flex',
            gap: '0.75rem',
            width: '100%',
            justifyContent: 'center'
          }}
        >
          <Box
            sx={boxStyles}
            onClick={() => onSelect('myself')}
          >
            <PersonOutlineOutlinedIcon
              sx={{
                fontSize: '2rem',
                color: '#828282',
                marginBottom: '0.25rem'
              }}
            />
            <Typography
              variant="body2"
              sx={{
                fontWeight: 500,
                whiteSpace: 'nowrap',
                textAlign: 'center',
                fontSize: '0.875rem'
              }}
            >
              Myself
            </Typography>
          </Box>

          <Box
            sx={boxStyles}
            onClick={() => onSelect('team-member')}
          >
            <GroupsOutlinedIcon
              sx={{
                fontSize: '2rem',
                color: '#828282',
                marginBottom: '0.25rem'
              }}
            />
            <Typography
              variant="body2"
              sx={{
                fontWeight: 500,
                whiteSpace: 'nowrap',
                textAlign: 'center',
                fontSize: '0.875rem'
              }}
            >
              A Team Member
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default CreateCardIndividualOrTeamMemberModal;
